<template>
  <div class="d-flex-column justify-start align-start gap-18">
    <div class="d-flex-column justify-start align-start gap-5">
      <h5 class="t-white font-family-1 title-h5">
        {{ $t("new.mythic_plus_dungeons") }}
      </h5>
      <p class="t-grey font-family-2 regular-l">
        {{ $t("new.select_mythic_plus_dungeons") }}
      </p>
    </div>
    <div
      class="d-flex-column select_honor_picker justify-start align-start gap-0"
    >
      <div class="d-flex-row space-between md-row-to-col">
        <button
          class="role_picker flex-5 gap-5 medium-l font-family-2 t-white"
          v-for="option in dungeonOptions"
          :key="option"
          @click="selectDungeon(option)"
          :class="[
            checkoutStore.getPackExtraOptions['dungeon'] === option.id &&
              'selected',
          ]"
        >
          {{ option.title }}
          <span class="t-blue">{{ renderPrice(option) }}</span>
        </button>
      </div>

      <div
        class="d-flex-column justify-start align-start gap-10"
        style="margin-top: 20px"
        v-if="isSpecificDungeon"
      >
        <p class="t-grey medium-m font-family-2 caps">
          {{ dungeons.length }} {{ $t("new.dungeons_remaining") }}
        </p>
        <div class="dungeons_list_container">
          <DungeonItemPicker
            v-for="dungeon in dungeons"
            :key="dungeon"
            :dungeon="dungeon"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { calculateCurrency } from "~/calculate/calculatePrice";
import DungeonItemPicker from "./DungeonItemPicker.vue";
import { ref, computed } from "vue";

const { currentGameSlug } = useGameComposable();
const { getLocale } = useFunctions();
const { getGamePack } = useGameStore();
const checkoutStore = useCheckoutStore();
const { getUserCurrencyCode } = useUserStore();
const dungeons = ref([]);
const dungeonSeason = ref("");
const dungeonOptions = computed(() => {
  if (getGamePack?.pack_extra_options) {
    return getGamePack?.pack_extra_options?.filter(
      (opt) => opt.description === "dungeon"
    );
  }
  return [];
});
const isSpecificDungeon = computed(() => {
    if (checkoutStore.getPackExtraOptions?.dungeon) {
      return (
        checkoutStore.getPackExtraOptions?.dungeon === dungeonOptions.value[1]?.id
      );
    }
  return false;
});

const selectDungeon = (packOption) => {
  checkoutStore.setPackExtraOptions({
    dungeon: packOption.id,
  });
};

const renderPrice = (packOption) => {
  if (packOption.type === "free") {
    return "";
  } else if (packOption.type === "variable") {
    return `+${packOption.price}%`;
  } else if (packOption.type === "fixed") {
    return `+${parseFloat(calculateCurrency(packOption.price)).toFixed(
      2
    )}${getUserCurrencyCode}`;
  } else {
    return `+${packOption.price}`;
  }
};

const { data: response, error } = await useApiFetch(
  `/api/get-mmo-game-dungeons/${currentGameSlug}`,
  {
    fetchKey: "get-mmo-game-dungeons",
  }
);
if (response.value?.data) {
  dungeonSeason.value = response.value?.data?.current_season;
  dungeons.value = response.value?.data?.dungeons;
}
</script>
